import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import CustomReminderAPI from '../../../api/CustomReminderAPI';
import Util from '../../../util/Util';
import withRouter from '../../../util/WithRouter';
import Display from '../../../util/Display';
import Const from '../../../util/Constants';
import ApiUiController from '../../../controller/ApiUiController';

class CustomReminderList extends React.Component {

  constructor(props) {
    super(props);
    this.autos = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path

    const model = reactLocalStorage.getObject(Const.Model).automation;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() { 
    if(this.List) {
      CustomReminderAPI.list(this.onReceived, this.onFail);
    }
  }
  onFail = () => this.setState({ inApiCall: false });
  onReceived = autos => { this.autos = autos; this.setState({ inApiCall: false }); }
  
  confirmDelete = index => {
    const message = `Are you sure you want to delete to ${this.autos[index].name}`;
    Util.confirmAlert('Delete', message, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      CustomReminderAPI.delete(this.autos[index].id,this.onDelete, this.onFail);
    });
  }
  onDelete = () => {
    Util.showNotification('Successful', 'Deleted successfully.', 'success');
    CustomReminderAPI.list(this.onReceived, this.onFail);
  }

  render() {
    if(!this.List) return null;
    const autoUI = this.autos.map((auto, _i) => (
      <tr key={`auto_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{auto.name}</td>
        <td>{auto.description}</td>
        <td>{Display.ModelLabelValue('user', auto.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(auto.created_date)}</td>
        <td>{Display.ModelLabelValue('user', auto.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(auto.updated_date)}</td>
        <td>
          { this.Update
            ? <NavLink to={`${this.path}/${auto.id}`} className="buttons update">
              <FaPencilAlt /> Update</NavLink>
            : null
          }
          { auto.status !== Const.AlwaysActive && this.Delete
            ? <span onClick={() => this.confirmDelete(_i)} className="buttons delete">
                <FaTrash /> Delete
              </span>
            : null
          }
        </td>
      </tr>
    ));

    return (
      <>
        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 pb-3"> <h3>Custom Reminder</h3> </div>
                <div className="col-md-6 text-right pb-3">
                  { this.Add &&
                    <NavLink to={`${this.path}/0`} className="buttons success">
                      Add Custom Reminder
                    </NavLink>
                  }
                </div>
                <div className="col-md-12">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Created By</th>
                        <th>Created Date</th>
                        <th>Updated By</th>
                        <th>Updated Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                      <tbody>
                        <ApiUiController inApiCall={this.props.inApiCall}>
                          { autoUI }
                        </ApiUiController>
                      </tbody>
                    </Table>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(CustomReminderList);
